import React from 'react';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../components/shared/PageHelmet';
import BlogsArea from './BlogsArea/BlogsArea';
import HomeTwoFooter from '../../components/MainFooter/MainFooter';
import NavHeader from '../../components/NavHeader/NavHeader';

const Blogs = () => {
   return (
      <>
         <PageHelmet
            pageTitle="Blog"
            description="Insights on software development, web development, mobile app development, AI, and SaaS from the Harsoft Solutions team."
            keywords="Software Development Blog, Web Development, Mobile App Development"
            path="/blogs"
         />

         <NavHeader/>
         <main>
            <CommonPageHeader title="Our Blog" subtitle="Blog" />
            <BlogsArea/>
         </main>
         <HomeTwoFooter/>
      </>
   );
};

export default Blogs;